import type { Cell, Dimension, ResolvedPalier, SingularityLevier } from '@mss_creator/shared';

/**
 * Group label for the 6 activation sub-rows (design doc M3). It is a *body
 * row* label carrying the block's single collapse control — never the table's
 * corner header cell, which the mockup leaves empty.
 */
export const ACTIVATION_ROW_LABEL = "Ligne d'activation";

/** Text of the collapsed activation band's single spanning cell (M15, mockup écran 18). */
export const ACTIVATION_ROW_COLLAPSED_HINT = 'Repliée — cliquer la flèche pour déplier';

/** Resolves a row's display label — the matching levier's `levierValeur` for
 * an `activation` row, or the dimension's `title` for a `dimension` row. */
export function resolveRowLabel(
  rowType: Cell['rowType'],
  rowRef: string,
  singularitySetup: SingularityLevier[],
  dimensions: Dimension[],
): string {
  if (rowType === 'activation') {
    const levier = singularitySetup.find((entry) => String(entry.order) === rowRef);
    return levier?.levierValeur ?? `Levier ${rowRef}`;
  }
  const dimension = dimensions.find((entry) => entry.id === rowRef);
  return dimension?.title ?? 'Dimension';
}

/** Resolves a column's display label from the resolved palier list. */
export function resolveColumnLabel(columnNumber: number, paliers: ResolvedPalier[]): string {
  const palier = paliers.find((entry) => entry.number === columnNumber);
  return palier?.label ?? `Palier ${columnNumber}`;
}
